module.exports = __webpack_public_path__ + "media/images/arrow_down_grey-b3c64e04fda3537f4340e04eb89baa3d.png";